/* eslint-disable */
import { Pose } from "@mediapipe/pose"
import { wait } from "./utils"
import FPSLimiter from './FPSLimiter';

const DEFAULT_POSE_OPTIONS = {
  modelComplexity: 1,
  smoothLandmarks: true,
  enableSegmentation: false,
  smoothSegmentation: false,
  minDetectionConfidence: 0.8,
  minTrackingConfidence: 0.5,
  useCpuInference: false,
}

const BLANK_IMAGE = new Image()
BLANK_IMAGE.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIwAAAABJRU5ErkJggg=='

const PoseDetector = {
  _pause: true,
  _pose: null,
  _poseResults: {},
  _videoElement: null,
  _fpsLimter: null,

  async init(options = {}) {
    const now = Date.now()
    if (this._pose == null) {
      this._fpsLimter = Number.isFinite(options.fps) ? new FPSLimiter(options.fps) : null

      this._pose = new Pose({
        locateFile: file => `/mediapipe/${file}`,
      })
      this._pose.setOptions({ ...DEFAULT_POSE_OPTIONS, ...options })
      this._pose.onResults((results) => {
        this._poseResults = results
      })
      await Promise.all([this._pose.initialize(), this.waitForBlankImage()])
      // send a blank image to kick-off the detector
      await this.send({ image: BLANK_IMAGE })
    }
    console.log('pose inited', (Date.now() - now) / 1000)
  },

  async waitForBlankImage() {
    if (!BLANK_IMAGE.complete) {
      await wait(0.1)
      await this.waitForBlankImage()
    }
  },

  async send(data) {
    if (this._fpsLimter && !this._fpsLimter.update()) { return }
    await this._pose.send(data)
  },

  start(videoElement) {
    this._videoElement = videoElement
    this.resume()
  },

  pause() {
    this._pause = true
  },

  resume() {
    this._pause = false
    this._onPoseUpdated()
  },

  stop() {
    this._pause = true
    this._videoElement = null
  },

  reset() {
    this._poseResults = {}
    this._pose.reset()
  },

  close() {
    this.stop();
    if (this._pose != null) {
      this._pose.close()
      this._pose = null
    }
  },

  getResults() {
    return this._poseResults
  },

  async _onPoseUpdated() {
    if (this._pause) { return }
    if (this._videoElement == null) { return }
    try {
      await this.send({ image: this._videoElement })
    } catch (err) {
      console.error(err)
      if (err.name.includes('RuntimeError')) {
        this.reset()
      }
    }
    requestAnimationFrame(() => this._onPoseUpdated())
  },
}

export default PoseDetector
